import React, { useEffect } from "react";
import "./FastSpringCheckoutForm.css";
import { API_URL } from "../../Constants";
import { useHistory } from "react-router-dom";
import axios from "axios";

let fastspringStorefront = process.env.REACT_APP_TEST_FASTSPRING_STORE_FRONT;
if (window.location.hostname === "www.styldod.com" || window.location.hostname === "app.styldod.com") {
    fastspringStorefront = process.env.REACT_APP_LIVE_FASTSPRING_STORE_FRONT;
}

const FastSpringCheckoutForm = ({
    formSchema,
    isCpnApplied,
    price,
    couponDis,
    coupon,
    setPbStep,
}) => {
    const history = useHistory();

    const loadCheckoutScript = () => {
        const scriptId = "fsc-api";
        let script = document.getElementById(scriptId);
        if (!script) {
            script = document.createElement("script");
            script.type = "text/javascript";
            script.id = scriptId;
            script.dataset.storefront = fastspringStorefront;
            script.setAttribute("data-popup-webhook-received", "dataPopupWebhookReceived");
            document.body.appendChild(script);
            script.addEventListener("load", () => {
                window.dispatchEvent(new Event("fastspring_script_loaded"))
            })
            script.src = "https://sbl.onfastspring.com/sbl/1.0.1/fastspring-builder.min.js";
        }
        return script;
    };

    const reloadCheckoutScript = () => {
        const scriptToCleanUp = document.getElementById("fsc-api");
        if (scriptToCleanUp) {
            scriptToCleanUp.remove();
        }
        return loadCheckoutScript();
    }

    const dataPopupWebhookReceived = async (orderReference) => {
        // This function is called on payment success.
        if (window.fs_fe_webh_counter > 0) return;
        window.fs_fe_webh_counter++;

        try {
          await axios({
            method: "PATCH",
            url: `${API_URL}/staging/update-order-payment-status`,
            data: {
                orderID: orderReference.tags.orderID,
                status: "processing"
            }
            });
        } catch(err) {}
        if (orderReference.tags.isCpnApplied) {
            try {
                const res = await axios({
                    method: "post",
                    url: `${API_URL}/coupon/applied`,
                    data: {
                        code: orderReference.tags.couponCode,
                        orderID: orderReference.tags.orderID,
                        o_amt: Number(orderReference.tags.couponDiscount) + Number(orderReference.tags.totalAmount),
                        d_amt: orderReference.tags.totalAmount,
                    },
                });
            } catch (err) { console.log("Coupan log failed to save: ", err) }
        }
        history.push(`/payment-successful?order-id=${orderReference.tags.orderID}&stype=${orderReference.tags.stype}&stl=me..69i57jA69FF59IjI0jJGD69iHF60l5.1721j0j7`)
    }

    useEffect(() => {
        const populateFastspringStorefront = async () => {
            const fsCheckoutSessionRes = await fetch(`${API_URL}/payment/fs_create_session`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ orderID: formSchema.orderID }),
            }).then((res) => res.json())

            // if (!window.dataPopupWebhookReceived) {
                window.fs_fe_webh_counter = 0;
                window.dataPopupWebhookReceived = dataPopupWebhookReceived;
            // }

            window.fastspring.builder.checkout(fsCheckoutSessionRes.fastspringSessionId)
            delete window.fastspring;
        }

        const initializeFastSpringCheckout = async () => {
            window.addEventListener("fastspring_script_loaded", populateFastspringStorefront)
            const checkoutScript = reloadCheckoutScript();
        }

        initializeFastSpringCheckout();

        return () => {
            window.removeEventListener("fastspring_script_loaded", populateFastspringStorefront)
        }
    }, []);

    return (
        <div id="fsc-embedded-checkout-container" style={{ maxWidth: "500px", margin: "auto" }}></div>
    );
};

export default FastSpringCheckoutForm;
